// Fabric-internal constants — engine-scoped values that never leak
// past the adapter.

const FONT_SIZE_MULTIPLIER = 4;

const FABRIC_CONTROL_COLOR = '#4467f1';

// Color painted outside the print zone (the canvas frame surrounding
// the editable surface). Never user-configurable, restored after
// clearCanvas().
const CANVAS_FRAME_BACKGROUND_COLOR = '#F5F5F7';

const CUTTING_PATH_SELECTION_OPACITY = 0.75;
const CUTTING_PATH_DEFAULT_OPACITY = 1;

const BACKGROUND_MASK_SELECTION_OPACITY = 0;
const BACKGROUND_MASK_DEFAULT_OPACITY = 1;

const MASK_MARGIN_PX = 2;

const TRANSPARENT_BG_INDICATOR_COLOR = '#FFFFFF';

export {
    BACKGROUND_MASK_DEFAULT_OPACITY,
    BACKGROUND_MASK_SELECTION_OPACITY,
    CANVAS_FRAME_BACKGROUND_COLOR,
    CUTTING_PATH_DEFAULT_OPACITY,
    CUTTING_PATH_SELECTION_OPACITY,
    FABRIC_CONTROL_COLOR,
    FONT_SIZE_MULTIPLIER,
    MASK_MARGIN_PX,
    TRANSPARENT_BG_INDICATOR_COLOR,
};
